module.exports = __webpack_public_path__ + "static/media/operador-logo-zenklub.1bdca911.svg";